module.exports = __webpack_public_path__ + "../front/img/368bøjlestang+2hylder.232c57af.svg";